let activeHighlight = null

export function cancelSpaceHighlight() {
  if (activeHighlight) {
    activeHighlight.cancel()
    activeHighlight = null
  }
}

export function highlightSpace(spaceId) {
  const el = document.querySelector(`[data-space-id="${spaceId}"]`)
  if (!el) return

  cancelSpaceHighlight()
  activeHighlight = el.animate(
    [
      { backgroundColor: "rgb(251 191 36 / 0.35)", offset: 0 },
      { backgroundColor: "rgb(251 191 36 / 0.35)", offset: 0.6 },
      { backgroundColor: "transparent", offset: 1 },
    ],
    { duration: 3000, easing: "ease-out" }
  )
}
